import Modal from "antd/lib/modal/Modal";
import React from "react";
import Title from "antd/lib/typography/Title";
import { Form, Input, InputNumber, Button, Spin, Space } from "antd";
import { useMutation } from "react-query";
import { NotificationHandler } from "../../../../util";
import { updateVendorItemRequest } from "../../../../api/VendorItemRequest";

const validateMessages = {
  required: "${label} is required!",
  types: {
    email: "${label} is not a valid email!",
    number: "${label} is not a valid number!",
  },
};

const EditVendorItemModal = ({
  visible,
  cancel,
  title,
  vendorItemRecord,
  refetch,
}) => {
  const [form] = Form.useForm();
  const initialValues = [
    {
      name: ["data", "id"],
      value: vendorItemRecord?.id,
    },
    {
      name: ["data", "itemName"],
      value: vendorItemRecord?.itemName,
    },
    {
      name: ["data", "value"],
      value: vendorItemRecord?.value,
    },
    {
      name: ["data", "stock"],
      value: vendorItemRecord?.stock,
    },
  ];

  const mutation = useMutation(updateVendorItemRequest, {
    onSuccess: (data, variables, context) => {
      const { data: response } = data;
      if (response?.error?.status === 1) {
        NotificationHandler("error", response.error.message);
      } else {
        NotificationHandler("success", response?.success?.message);
        refetch();
        cancel();
        form.resetFields();
        //   navigate(`/${title.toLowerCase()}`);
      }
    },
    onError: (error, variables, context) => {
      NotificationHandler("error", error.message);
    },
  });

  const onFinish = (values) => {
    mutation.mutate(values);
  };
  return (
    <Modal visible={visible} onCancel={cancel} footer={[]}>
      <Title className="mt-5 " level={4}>
        {title}
      </Title>
      <div>
        <Form
          layout="vertical"
          name="nest-messages"
          onFinish={onFinish}
          validateMessages={validateMessages}
          fields={initialValues}
          form={form}
        >
          <Form.Item name={["data", "id"]} label="id" hidden>
            <Input />
          </Form.Item>
          <Form.Item
            name={["data", "itemName"]}
            label="Item Name"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name={["data", "value"]}
            label="Value"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <InputNumber style={{ width: "100%" }} />
          </Form.Item>
          <Form.Item
            name={["data", "stock"]}
            label="Available Stock"
            rules={[
              {
                // type: "number",
                required: true,
              },
            ]}
          >
            <InputNumber style={{ width: "100%" }} />
          </Form.Item>

          <Form.Item>
            <Space size="middle">
              <Button type="default" onClick={cancel}>
                Cancel
              </Button>
              <Button
                type="primary"
                htmlType="submit"
                //   disabled={mutation.isLoading}
              >
                Update
              </Button>
              {mutation.isLoading && <Spin />}
            </Space>
          </Form.Item>
        </Form>
      </div>
    </Modal>
  );
};

export default EditVendorItemModal;
